<template lang="pug">
.navbar-container
  f7-navbar
    f7-nav-left
      template(v-if="isShowBack")
        f7-link(
          v-if="popupClose"
          class="icon-link"
          icon-f7="close"
          icon-color="white"
          @close="$emit('close')")
        f7-link(
          v-else
          class="back-button"
          icon="icon-back"
          icon-color="white"
          @click="$emit('click')")
      template(v-else)
        slot(name="left")

    f7-nav-title(v-if="title") {{ title }}

    f7-nav-right
      slot(name="right")

</template>

<style lang="scss">
.navbar-container {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 500;

  .navbar {
    background-color: rgba(25, 39, 52, 1);
    height: 56px;

    &::after {
      background-color: rgba(25, 39, 52, 1);
    }

    .left {
      position: absolute;

      .icon-link {
        width: 100% !important;
      }

      .back-button {
        width: 100% !important;
        padding: 0 10px;
      }
    }

    .title {
      left: 50% !important;
      transform: translateX(-50%);
      margin: unset;
    }
  }
}

.navbar-container ~ .page-content {
  padding-top: 56px;
}
</style>

<script>
export default {
  props: {
    title: String,
    'popup-close': { type: Boolean, default: false },
    back: { type: Boolean, default: false },
  },
  computed: {
    isShowBack() {
      return this.back || this.popupClose
    },
  },
}
</script>
